module.exports = __webpack_public_path__ + "static/media/view1.563d71ad.jpg";